import { create } from 'zustand';

const initStateData = {
	socket: null,
};

export const useSocketStore = create(set => ({
	...initStateData,

	setSocket: data =>
		set(() => {
			return {
				socket: data,
			};
		}),
}));
